var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84137 1.06506C8.17345 1.38372 8.18433 1.91124 7.86567 2.24332L3.6214 6.66636L7.50017 6.66639C13.9435 6.66639 19.1668 11.8897 19.1668 18.3331C19.1668 18.7933 18.7937 19.1664 18.3335 19.1664C17.8733 19.1664 17.5002 18.7933 17.5002 18.3331C17.5002 12.8102 13.023 8.33306 7.50016 8.33306L3.62144 8.33302L7.86567 12.756C8.18433 13.0881 8.17345 13.6156 7.84137 13.9343C7.50929 14.2529 6.98177 14.2421 6.66311 13.91L1.06555 8.07665C0.756146 7.75422 0.756146 7.24513 1.06555 6.9227L6.66311 1.08936C6.98177 0.757285 7.50929 0.746404 7.84137 1.06506Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowReply);
export default __webpack_public_path__ + "static/media/Arrow-Reply.6e3e45d9831c022932f7d03a3672d34c.svg";
export { ForwardRef as ReactComponent };